import { render, staticRenderFns } from "./CmgVerificationSystemErrorModal.vue?vue&type=template&id=a51c5d7a&scoped=true&lang=pug&"
import script from "./cmg-verification-system-error-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-verification-system-error-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgVerificationSystemErrorModal.vue?vue&type=style&index=0&id=a51c5d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51c5d7a",
  null
  
)

export default component.exports